import type { StorageAdapter } from '../../core';

/**
 * 浏览器端本地存储适配器
 * 封装 localStorage，内置隐私模式及无 window 环境的内存兜底
 */
export class BrowserStorage implements StorageAdapter {
  private memoryFallback = new Map<string, string>();
  private isAvailable: boolean;

  constructor() {
    this.isAvailable = this.checkAvailability();
  }

  private checkAvailability(): boolean {
    try {
      if (typeof window === 'undefined' || !window.localStorage) return false;
      const testKey = '__hss_test_storage__';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return true;
    } catch {
      return false;
    }
  }

  public getItem(key: string): string | null {
    if (!this.isAvailable) {
      return this.memoryFallback.get(key) ?? null;
    }
    try {
      return window.localStorage.getItem(key);
    } catch {
      return this.memoryFallback.get(key) ?? null;
    }
  }

  public setItem(key: string, value: string): void {
    if (!this.isAvailable) {
      this.memoryFallback.set(key, value);
      return;
    }
    try {
      window.localStorage.setItem(key, value);
    } catch {
      this.memoryFallback.set(key, value);
    }
  }

  public removeItem(key: string): void {
    if (!this.isAvailable) {
      this.memoryFallback.delete(key);
      return;
    }
    try {
      window.localStorage.removeItem(key);
    } catch {
      this.memoryFallback.delete(key);
    }
  }
}
